module.exports = __webpack_public_path__ + "394b039c7f4609d9d433c891bd56ecfd.svg";